/*
 * @Description  : 文库类型管理
 * @Author       : zcc
 * @Date         : 2025-04-24 17:20:24
 * @LastEditors  : zcc
 * @LastEditTime : 2025-04-28 14:15:46
 * @FilePath     : \ngs_platform_manage_admin\src\api\modules\library\library-type-management\index.js
 */
import request from "../../../request.js";

// 文库类型管理-新建 -- -- 徐仲阳
export const saveLibDocType = function (data) {
  return request({
    url: "/docType/saveLibDocType",
    method: "post",
    data
  });
};
// 文库类型管理-列表  -- 徐仲阳
export const libDocTypeTreeList = function (data) {
  return request({
    url: "/docType/libDocTypeTreeList",
    method: "post",
    data
  });
};

// 文库类型管-查看详情  ---- 徐仲阳
export const libDocTypeInfo = function (data) {
  return request({
    url: "/docType/libDocTypeInfo",
    method: "post",
    data
  });
};

// 文库类型管理-排序 -- 徐仲阳
export const changeSort = function (data) {
  return request({
    url: "/docType/changeSort",
    method: "post",
    data
  });
};

// 文库类型管理-变更状态   -- 徐仲阳
export const updateStatus = function (data) {
  return request({
    url: "/docType/updateStatus",
    method: "post",
    data
  });
};

// 文库类型管理- 已关联文库列表   --  朱新宇
export const selectDocManage = function (data) {
  return request({
    url: "/docType/selectDocManage",
    method: "post",
    data
  });
};

// 文库类型管理- 已关联文库删除   --  朱新宇
export const delDocManage = function (data) {
  return request({
    url: "/docType/delDocManage",
    method: "post",
    data
  });
};

// 文库类型管理-文库类型关联文库   --  朱新宇
export const relateDocManage = function (data) {
  return request({
    url: "/docType/relateDocManage",
    method: "post",
    data
  });
};

// 文库类型管理-变更关联文库排序   --  徐仲阳
export const setSort = function (data) {
  return request({
    url: "/docType/setSort",
    method: "post",
    data
  });
};

// 删除节点 -- 沈洋
export const delDocType = function (data) {
  return request({
    url: "/docType/delDocType",
    method: "post",
    data
  });
};
